import { useMemo } from 'react';
import { branchesListAdapter } from '../libs/branchAdapter';
import { useQuery } from '@tanstack/react-query';
import { branchAPI } from '../api/branchAPI';

export const useGetBranches = (lat: number, lng: number, enabled = true) => {
  const language = localStorage.getItem('language') || 'uz';
  const initData = useMemo(() => ({ branches: branchesListAdapter() }), []);
  const { data = initData, isLoading } = useQuery({
    // The request carries the language as a header, so a cached list belongs to
    // the language it was fetched in — without this the branch names would stay
    // in the previous language after a switch.
    queryKey: ['branches', language],
    queryFn: async () => await branchAPI.getBranches(lat, lng),
    select: data => ({
      branches: branchesListAdapter(data.data),
    }),
    enabled,
  });
  return {
    ...data,
    isLoading,
  };
};

// Same shape as useGetBranches, but scoped to branches that offer self-pickup.
export const useGetPickupBranches = (
  lat: number,
  lng: number,
  enabled = true
) => {
  const language = localStorage.getItem('language') || 'uz';
  const initData = useMemo(() => ({ branches: branchesListAdapter() }), []);
  const { data = initData, isLoading } = useQuery({
    queryKey: ['pickup-branches', language],
    queryFn: async () => await branchAPI.getPickupBranches(lat, lng),
    select: data => ({
      branches: branchesListAdapter(data.data),
    }),
    enabled,
  });
  return {
    ...data,
    isLoading,
  };
};
